export let onlyView = {
    cart:'cart',// 购物车页面
    billsCP:'billsCP',// 订单页面
    generateOrderDetail:'generateOrderDetail',// 订单详情页面
    productDetail:'productDetail',// 产品详情页面
    packOrder:'packOrder',// 打包单页面
    addEditPackOrder:'addEditPackOrder',// 打包单详情页面
    giftOrder:'giftOrder',// 礼品单详情页面
    materialObject:'materialObject',//有实物退货单
    noMaterialObject:'noMaterialObject'//无实物退货单
}


// WEBPACK FOOTER //
// ./src/utils/onlyView.js